import { appstr } from "../utils/appstr";
import {
  enumColorPickAdvMode,
  enumFillMode,
  enumPanelBorderStyle,
  kCCPHeight,
  kColRowSpacing,
  kLeftOffset,
  kNumCols,
  kNumRows,
  kPickerColorCodes,
  kPickerColors,
  kSmallCPButton,
  kSmallCPHeightNoFill,
  kTopOffset
} from "../constants";
import { QColorButton } from "./QColorButton";
import { QCustomColorPicker } from "./QCustomColorPicker";
import { QPanel } from "./QPanel";
import { QPoint } from "./QPoint";
import { QAdvFillColorButton } from "./QAdvFillColorButton";
import { QColorPickerResult } from "./QColorPickerResult";

export class QColorPicker extends QPanel {
  constructor() {
    super();
    this.fBaseCode = null;
    this.fCustomColors = null;
    this.fStartColor = null;
    this.fStartColor2 = null;
    this.fStartFillMode = null;
  }

  SetupCustomColors(customColors) {
    this.fCustomColors = [];
    if (customColors != null) {
      for (var x = 0; x < customColors.length; x++) this.fCustomColors.push(customColors[x]);
    }

    while (this.fCustomColors.length < kNumCols) this.fCustomColors.push("#FFFFFF");
  }

  GetPickerWidth() {
    var kSmallCPWidth = kNumCols * kSmallCPButton + (kNumCols + 1) * 2;
    return kSmallCPWidth;
  }

  SetReturn(returnPanel) {
    this.fReturn = returnPanel;
  }

  GetPickerHeight() {
    var numRows = kNumRows;
    if (!this.fEnableCustom) numRows -= 1;

    var kSmallCPHeight = numRows * kSmallCPButton + (numRows + 1) * 2;
    return kSmallCPHeight;
  }

  InitColorPicker(
    wsMgr,
    baseCode,
    startColor,
    startColor2,
    startFillMode,
    enableNoFill,
    customColors,
    advMode,
    enableCustom
  ) {
    this.fWSMgr = wsMgr;
    this.fStartColor = startColor;
    this.fStartColor2 = startColor2;
    this.fStartFillMode = startFillMode;
    this.fEnableCustom = enableCustom;
    this.SetupCustomColors(customColors);
    var rowHeight = kSmallCPButton + kColRowSpacing;
    var CPHeight = this.GetPickerHeight();
    if (enableNoFill) CPHeight = kSmallCPHeightNoFill;

    var kSmallCPWidth = this.GetPickerWidth(); // kNumCols * kSmallCPButton + (kNumCols+1)*2;
    this.SizePanel(kSmallCPWidth, CPHeight);
    this.SetModalOn(true);
    this.SetOutsideClickDismissOn(true);
    this.fUIColors = wsMgr.GetUIColors();
    this.fTextColor = this.fUIColors.GetHeaderTextColor();
    this.SetFillColor(this.fUIColors.GetSecondaryPanelFillColor());
    this.SetShadowOn(true);
    this.SetBorderStyle(enumPanelBorderStyle.singleBorder);
    this.SetNeedsCustomResize(true);
    this.fBaseCode = baseCode; //+ "-";

    var x, y;
    var counter = 0;
    var colWidth = kSmallCPButton + kColRowSpacing;
    var buttonCmdCode;
    var foundStartColor = false;
    var numRows = kNumRows;
    if (!enableCustom) numRows -= 1;

    for (y = 0; y < numRows; y++) {
      for (x = 0; x < kNumCols; x++) {
        var isCustom = enableCustom && y == numRows - 1;
        var colorButton = new QColorButton();
        colorButton.PositionElement(x * colWidth + kLeftOffset, y * rowHeight + kTopOffset);
        colorButton.SizeElement(kSmallCPButton, kSmallCPButton);
        buttonCmdCode = this.fBaseCode + "-";
        buttonCmdCode = buttonCmdCode.concat(counter);
        colorButton.SetColorCode(kPickerColorCodes[counter]);
        if (isCustom) kPickerColors[counter] = this.fCustomColors[x];

        var interiorColor = kPickerColors[counter++];
        colorButton.SetInteriorColor(interiorColor);

        if (!foundStartColor) {
          if (startColor == interiorColor && startFillMode != enumFillMode.noFill) {
            // || startFillMode == enumFillMode.dashline))
            colorButton.SetAsStartColor(true);
            foundStartColor = true;
          }
        }

        colorButton.SetCmdCode(buttonCmdCode);
        this.PushElement(colorButton);

        if (isCustom) {
          var buttSize = 8;
          var miniButton = new QColorButton();
          miniButton.SizeElement(buttSize, buttSize);
          var xM = colorButton.GetPositionX() + colorButton.GetWidth() - buttSize;
          var yM = colorButton.GetPositionY() + colorButton.GetHeight() - buttSize;
          miniButton.PositionElement(xM, yM);
          miniButton.SetInteriorColor("#C5E0B3");
          var miniCmdCode = "CustomColor-" + x;
          miniButton.SetCmdCode(miniCmdCode);
          miniButton["parent"] = colorButton;
          this.PushElement(miniButton);
        }
      }
    }

    var yPos = numRows * rowHeight + kTopOffset;
    if (enableNoFill) {
      var noFillButton = new QAdvFillColorButton();
      noFillButton.InitAdvButton(appstr("nofill"));
      noFillButton.PositionElement(kLeftOffset, yPos);
      var nCols = kNumCols;
      if (advMode != enumColorPickAdvMode.disabled) nCols = nCols - 1;
      noFillButton.SizeElement(colWidth * nCols - kColRowSpacing, kSmallCPButton);

      if (startFillMode == enumFillMode.noFill) noFillButton.SetAsStartColor(true);

      var buttonCmdCode = this.fBaseCode + "-";
      buttonCmdCode = buttonCmdCode.concat("NoFill");
      noFillButton.SetCmdCode(buttonCmdCode);
      this.PushElement(noFillButton);
      //yPos += rowHeight;

      if (advMode != enumColorPickAdvMode.disabled) {
        var advButton = new QAdvFillColorButton();
        advButton.InitAdvButton("...");
        var advX = kLeftOffset + noFillButton.GetWidth() + kColRowSpacing;
        advButton.PositionElement(advX, yPos);
        advButton.SizeElement(colWidth - kColRowSpacing, kSmallCPButton);

        if (advMode == enumColorPickAdvMode.full) buttonCmdCode = "AdvColorOptions-";
        else buttonCmdCode = "AdvColorOptionsLtd-";

        buttonCmdCode = buttonCmdCode.concat("AdvFillOptions");
        advButton.SetCmdCode(buttonCmdCode);
        this.PushElement(advButton);
      }
    }
  }

  DoCustomResize() {
    this.fWSMgr.RemovePanel(this);
  }

  AdjustPlacement(x, y, pickerWidth, pickerHeight, backGroundPanel) {
    //  var pickerWidth = this.GetPickerWidth();
    var pickerRight = x + pickerWidth;
    var canvasWidth = backGroundPanel.fWidth;
    if (pickerRight > canvasWidth) x = x - (pickerRight - canvasWidth) - 4;

    // var pickerHeight = this.GetPickerHeight();
    var pickerBottom = y + pickerHeight;
    var canvasHeight = backGroundPanel.GetPositionY() + backGroundPanel.fHeight;
    if (pickerBottom > canvasHeight) y = y - (pickerBottom - canvasHeight) - 4;

    var p = new QPoint();
    p.InitPoint(x, y);

    return p;
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var wsMgr = aCmd.GetWSMgr();
    var panelHandled = false;
    var srcButton = aCmd.GetSourceElement();
    var parent = this["parent"];

    var parts = cmdCode.split("-");

    var subCode = parts[0];
    if (subCode == "TriColor1S") {
      var c1 = srcButton.GetInteriorColor();
      parent.SetColor1(c1);
      panelHandled = true;
    } else if (subCode == "TriColor2S") {
      var c2 = srcButton.GetInteriorColor();
      parent.SetColor2(c2);
      panelHandled = true;
    } else if (subCode == this.fBaseCode) {
      var result = new QColorPickerResult();
      var colorNum = parts[1];
      switch (colorNum) {
        case "NoFill":
          result.fFillMode = enumFillMode.noFill;
          break;
        case "Separator":
          result.fFillMode = enumFillMode.separator;
          result.fSelectedColor = this.fStartColor;
          break;
        case "DashLine":
          result.fFillMode = enumFillMode.dashline;
          result.fSelectedColor = this.fStartColor;
          break;
        case "Triangle":
          result.fFillMode = enumFillMode.triangle;
          result.fSelectedColor = aCmd["newColor"];
          result.fSelectedColor2 = aCmd["newColor2"];
          break;
        case "LeftTriangle":
          result.fFillMode = enumFillMode.lefttriangle;
          result.fSelectedColor = aCmd["newColor"];
          result.fSelectedColor2 = aCmd["newColor2"];
          break;
        case "GradientFill":
          result.fFillMode = enumFillMode.linearGradientDown;
          result.fSelectedColor = aCmd["newColor"];
          result.fSelectedColor2 = aCmd["newColor2"];
          break;
        case "SolidFill":
          result.fFillMode = enumFillMode.solidFill;
          if (this.fStartFillMode == null || this.fStartFillMode == enumFillMode.noFill)
            this.fStartColor = "#F2F2F2";
          result.fSelectedColor = this.fStartColor;
          break;
        default:
          result.fSelectedColor = srcButton.GetInteriorColor();
          if (this.fStartFillMode == null || this.fStartFillMode == enumFillMode.noFill)
            this.fStartFillMode = enumFillMode.solidFill;
          result.fFillMode = this.fStartFillMode;
          break;
      }

      aCmd["CPResult"] = result;
      if (this.fReturn) this.fReturn.ExecuteCommand(aCmd);
      panelHandled = true;
    } else if (subCode == "CustomColor") {
      var customIndex = parseInt(parts[1]);
      this.DoCustomColorPicker(wsMgr, this.fCustomColors, customIndex, srcButton);
    } else if (subCode == "AdvColorOptions") {
      this.DoAdvFillOptions(wsMgr, enumColorPickAdvMode.full, srcButton);
    } else if (subCode == "AdvColorOptionsLtd") {
      this.DoAdvFillOptions(wsMgr, enumColorPickAdvMode.limited, srcButton);
    }

    switch (cmdCode) {
      case "CNCL":
        panelHandled = true;
        break;
    }

    if (panelHandled) {
      wsMgr.RemovePanel(this);
      if (parent && parent instanceof QPanel) aCmd["callbackPanel"] = parent;
    }

    return panelHandled;
  }

  DoAdvFillOptions(wsMgr, advMode, srcElement) {
    var height = this.GetHeight();
    var xPos = this.GetPositionX();
    var yPos = this.GetPositionY() + height + 6;
    var theWidth = this.GetWidth();

    var pickerPos = this.AdjustPlacement(
      xPos,
      yPos,
      theWidth,
      kCCPHeight,
      wsMgr.GetBackgroundPanel()
    );

    const QAdvOptsPicker = require("./QAdvOptsPicker").QAdvOptsPicker;
    var advOpts = new QAdvOptsPicker();
    advOpts.InitAdvOptsPicker(
      wsMgr,
      theWidth,
      this,
      this.fStartFillMode,
      this.fStartColor,
      this.fStartColor2,
      this.fBaseCode,
      advMode
    );
    advOpts.PositionPanel(pickerPos.fX, pickerPos.fY);
    wsMgr.PushPanel(advOpts);
    advOpts.SmartPositionPanel(srcElement);
    advOpts.BecomeKeyboardTarget();
  }

  DoCustomColorPicker(wsMgr, colorList, colorIndex, srcElement) {
    var height = this.GetHeight();
    var xPos = this.GetPositionX();
    var yPos = this.GetPositionY() + height + 6;
    var theWidth = this.GetWidth();

    var pickerPos = this.AdjustPlacement(
      xPos,
      yPos,
      theWidth,
      kCCPHeight,
      wsMgr.GetBackgroundPanel()
    );

    var ccp = new QCustomColorPicker();
    ccp.InitCustomColorPicker(wsMgr, theWidth, colorList, colorIndex, srcElement);
    ccp.PositionPanel(pickerPos.fX, pickerPos.fY);
    wsMgr.PushPanel(ccp);
    ccp.SmartPositionPanel(srcElement);
    ccp.BecomeKeyboardTarget();
  }
}
